import React from 'react'


export default function Footer() {
  return (
    <footer>
      <div className="py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">

          {/* Top area: Blocks */}
          <div className="grid md:grid-cols-12 gap-8 lg:gap-20 mb-8 md:mb-12">

            {/* 1st block */}
            <div className="md:col-span-4 lg:col-span-5">
              <div className="mb-2">
                {/* Logo */}
                {/* <div to="" className="inline-block" aria-label="Cruip"> */}
                  <svg className="w-8 h-8 fill-current text-purple-600" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path d="M31.952 14.751a260.51 260.51 0 00-4.359-4.407C23.932 6.734 20.16 3.182 16.171 0c1.634.017 3.21.28 4.692.751 3.487 3.114 6.846 6.398 10.163 9.737.493 1.346.811 2.776.926 4.262zm-1.388 7.883c-2.496-2.597-5.051-5.12-7.737-7.471-3.706-3.246-10.693-9.81-15.736-7.418-4.552 2.158-4.717 10.543-4.96 16.238A15.926 15.926 0 010 16C0 9.799 3.528 4.421 8.686 1.766c1.82.593 3.593 1.675 5.038 2.587 6.569 4.14 12.29 9.71 17.792 15.57-.237.94-.557 1.846-.952 2.711zm-4.505 5.81a56.161 56.161 0 00-1.007-.823c-2.574-2.054-6.087-4.805-9.394-4.044-3.022.695-4.264 4.267-4.97 7.52a15.945 15.945 0 01-3.665-1.85c.366-3.242.89-6.675 2.405-9.364 2.315-4.107 6.287-3.072 9.613-1.132 3.36 1.96 6.417 4.572 9.313 7.417a16.097 16.097 0 01-2.295 2.275z" />
                  </svg>
                {/* </div> */}
              </div>
              <div className="text-gray-400">Modern Software Solutions Provide you best services in market in management of your products from end to end development and deployment.</div>
            </div>

            {/* 2nd, 3rd and 4th blocks */}
            <div className="md:col-span-8 lg:col-span-7 grid sm:grid-cols-3 gap-8">

              {/* 2nd block */}
              <div >
              <div  className="text-sm">
               
                <ul>
                <li>
                <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} className="text-gray-200 font-medium mb-1 ">Products</div>
                </li>
                  <li  className="mb-1">
                    <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Android App</div>
                  </li>
                  <li className="mb-1">
                    <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} to="" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Desktop App</div>
                  </li>
                  <li className="mb-1">
                    <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} to="" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Ios App</div>
                  </li>
                  <li className="mb-1">
                    <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} to="" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Web App</div>
                  </li>
                </ul>
              </div>
              </div>

              {/* 3rd block */}
              <div  className="text-sm">
                
                <ul >
                  <li>
                  <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} className="text-gray-200 font-medium ">Services</div>
                  </li>
                  <li className="mb-1">
                    <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Eductaion Managemnt</div>
                  </li>
                  <li  className="mb-1">
                    <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Billing Managemnt</div>
                  </li>
                  <li className="mb-1">
                    <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Hotel Managemnt</div>
                  </li>
                  <li className="mb-1">
                    <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Resturant Managemnt</div>
                  </li>
              
                </ul>
              </div>

              {/* 4th block */}
              <div className="text-sm">
               
                <ul>
                  <li>
                  <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} className="text-gray-200 font-medium mb-1">Company</div>
                  </li>
                  <li  className="mb-1">
                    <div style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} to="" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Govind Chak</div>
                  </li>
                  <li className="mb-1">
                    <div to="" style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}} className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out">Sonpur,Saran</div>
                  </li>
                  <li className="mb-1">
                    <div to="" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out" style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}}>841101</div>
                  </li>
                  <li className="mb-1">
                    <div to="" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out" style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}}>Bihar</div>
                  </li>
                  <li className="mb-1">
                    <div to="" className="text-gray-400 hover:text-gray-100 transition duration-150 ease-in-out" style={{display:"flex",justifyContent:"flex-start",flexDirection:"row"}}>India</div>
                  </li>
                </ul>
              </div>

            </div>

          </div>

          {/* Bottom area */}
          <div className="md:flex md:items-center md:justify-between">

            {/* Social divs */}
            <ul className="flex mb-4 md:order-1 md:ml-4 md:mb-0">
              <li>
                <div to="" className="flex justify-center items-center text-purple-600 bg-gray-800 hover:text-gray-100 hover:bg-purple-600 rounded-full transition duration-150 ease-in-out" aria-label="Twitter">
                  <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path d="m13.063 9 3.495 4.475L20.601 9h2.454l-5.359 5.931L24 23h-4.938l-3.866-4.893L10.771 23H8.316l5.735-6.342L8 9h5.063Zm-.74 1.347h-1.457l8.875 11.232h1.36l-8.778-11.232Z" />
                  </svg>
                </div>
              </li>
              <li className="ml-4">
                <div to="" className="flex justify-center items-center text-purple-600 bg-gray-800 hover:text-gray-100 hover:bg-purple-600 rounded-full transition duration-150 ease-in-out" aria-label="Github">
                  <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 8.2c-4.4 0-8 3.6-8 8 0 3.5 2.3 6.5 5.5 7.6.4.1.5-.2.5-.4V22c-2.2.5-2.7-1-2.7-1-.4-.9-.9-1.2-.9-1.2-.7-.5.1-.5.1-.5.8.1 1.2.8 1.2.8.7 1.3 1.9.9 2.3.7.1-.5.3-.9.5-1.1-1.8-.2-3.6-.9-3.6-4 0-.9.3-1.6.8-2.1-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.2.8.6-.2 1.3-.3 2-.3s1.4.1 2 .3c1.5-1 2.2-.8 2.2-.8.4 1.1.2 1.9.1 2.1.5.6.8 1.3.8 2.1 0 3.1-1.9 3.7-3.7 3.9.3.4.6.9.6 1.6v2.2c0 .2.1.5.6.4 3.2-1.1 5.5-4.1 5.5-7.6-.1-4.4-3.7-8-8.1-8z" />
                  </svg>
                </div>
              </li>
              <li className="ml-4">
                <div to="" className="flex justify-center items-center text-purple-600 bg-gray-800 hover:text-gray-100 hover:bg-purple-600 rounded-full transition duration-150 ease-in-out" aria-label="Facebook">
                  <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                  </svg>
                </div>
              </li>
              <li className="ml-4">
                <div to="" className="flex justify-center items-center text-purple-600 bg-gray-800 hover:text-gray-100 hover:bg-purple-600 rounded-full transition duration-150 ease-in-out" aria-label="Instagram">
                  <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20.145" cy="11.892" r="1" />
                    <path d="M16 20c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0-6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z" />
                    <path d="M20 24h-8c-2.056 0-4-1.944-4-4v-8c0-2.056 1.944-4 4-4h8c2.056 0 4 1.944 4 4v8c0 2.056-1.944 4-4 4zm-8-14c-.935 0-2 1.065-2 2v8c0 .953 1.047 2 2 2h8c.935 0 2-1.065 2-2v-8c0-.935-1.065-2-2-2h-8z" />
                  </svg>
                </div>
              </li>
              <li className="ml-4">
                <div to="" className="flex justify-center items-center text-purple-600 bg-gray-800 hover:text-gray-100 hover:bg-purple-600 rounded-full transition duration-150 ease-in-out" aria-label="divedin">
                  <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.3 8H8.7c-.4 0-.7.3-.7.7v14.7c0 .3.3.6.7.6h14.7c.4 0 .7-.3.7-.7V8.7c-.1-.4-.4-.7-.8-.7zM12.7 21.6h-2.3V14h2.4v7.6h-.1zM11.6 13c-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4-.1.7-.7 1.4-1.4 1.4zm10 8.6h-2.4v-3.7c0-.9 0-2-1.2-2s-1.4 1-1.4 2v3.8h-2.4V14h2.3v1c.3-.6 1.1-1.2 2.2-1.2 2.4 0 2.8 1.6 2.8 3.6v4.2h.1z" />
                  </svg>
                </div>
              </li>
            </ul>

            {/* Copyrights note */}
            <div className="text-gray-400 text-sm mr-4">&copy; modernsoftwaresolutions.com. All rights reserved.</div>

          </div>

        </div>
      </div>
    </footer>
  )
}
